import React from 'react';
import SEO from '../../../component/common/SEO';
import { pageSEO } from '../../../config/seoConfig';
import OfferImage from '../../../assets/images/about/offer.png';
import MissionVissionImg from '../../../assets/images/about/mission-vission.png';
import './style.css';

export default function AboutUs() {
  return (
    <div className="w-full bg-[#F7F7F7] text-slate-800">
      <SEO {...pageSEO.about} />
      {/* Banner */}
      <section className="about-banner">
        {/* <h1 className="text-white text-3xl sm:text-4xl md:text-5xl font-extrabold text-center drop-shadow">
          About Us
        </h1> */}
      </section>

      {/* Intro */}
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Text (exact content – styled via about-intro-card) */}
          <div className="about-intro-card">
            <div className="mt-1 space-y-4 text-[15px] leading-7 text-slate-700">
              <p>Empowering India to Import Smarter — Not Harder.</p>
              <p>
                Importerr is India’s <strong>first AI-powered B2B cross-border sourcing platform</strong>, designed to simplify how businesses
                discover, source, and import global products.
              </p>
              <p>
                We combine <strong>AI technology, global supplier access, and end-to-end logistics</strong>
                to make importing seamless — from product discovery to delivery.
                <br />
                Importerr eliminates the hassle of middlemen, complex negotiations, and unreliable suppliers, offering a
                <strong> transparent, tech-driven, and trustworthy importing experience.</strong>
              </p>
              <p>
                Whether you’re a <strong> D2C brand, marketplace seller, startup founder, student, or homemaker</strong>, Importerr enables you to
                <strong>build your own business with a 1-MOQ model</strong>, making it possible to start small, test products, and grow confidently
                without heavy investment or inventory risks.
              </p>
              <p>
                At Importerr, we believe global sourcing should be
                <strong>as simple as a single search — </strong>
                empowering every entrepreneur to access the world’s best products and opportunities.
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="absolute -inset-4 -z-10 rounded-3xl bg-gradient-to-tr from-sky-100 via-indigo-100 to-teal-100 blur-2xl" />
            <img
              src={OfferImage}
              alt="Importerr Overview"
              className="w-full rounded-2xl shadow-xl h-[350px] md:h-[400px] lg:h-[480px] object-cover"
            />
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-6 sm:py-10 bg-slate-50">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10 items-stretch">
            {/* Illustration */}
            <div className="lg:col-span-1">
              <div className="relative h-full">
                <div className="absolute -inset-3 -z-10 rounded-3xl bg-gradient-to-br from-cyan-100 to-purple-100 blur-2xl" />
                <img src={MissionVissionImg} alt="Mission & Vision" className="w-full rounded-2xl shadow-lg" />
              </div>
            </div>

            {/* Mission */}
            <div className="lg:col-span-1 mv-card">
              <h3 className="mv-title">Our Mission</h3>
              <p className="mv-text">
                To <strong>simplify and democratize global sourcing</strong>
                for every entrepreneur in India by leveraging AI, technology, and transparency — enabling them to
                <strong>start, scale, and succeed</strong> without barriers.
              </p>
            </div>

            {/* Vision */}
            <div className="lg:col-span-1 mv-card">
              <h3 className="mv-title">Our Vision</h3>
              <p className="mv-text">
                To become <strong> India’s most trusted and intelligent cross-border sourcing ecosystem</strong>, connecting global suppliers with
                Indian businesses and
                <strong>redefining how the world imports.</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Metrics (kept commented for future use) ===== */}
      {/* 
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <div className="rounded-xl bg-white border border-black/5 p-5 text-center shadow-sm">
            <p className="text-2xl font-extrabold text-slate-900">956+</p>
            <p className="text-sm text-slate-600 mt-1">Employee Empowered</p>
          </div>
          <div className="rounded-xl bg-white border border-black/5 p-5 text-center shadow-sm">
            <p className="text-2xl font-extrabold text-slate-900">100</p>
            <p className="text-sm text-slate-600 mt-1">Worldwide Distributors</p>
          </div>
          <div className="rounded-xl bg-white border border-black/5 p-5 text-center shadow-sm">
            <p className="text-2xl font-extrabold text-slate-900">750+</p>
            <p className="text-sm text-slate-600 mt-1">Receive Daily Ordered</p>
          </div>
          <div className="rounded-xl bg-white border border-black/5 p-5 text-center shadow-sm">
            <p className="text-2xl font-extrabold text-slate-900">900</p>
            <p className="text-sm text-slate-600 mt-1">Get Growth Per Years</p>
          </div>
        </div>
      </section>
      */}
      {/* ===== End Metrics ===== */}

      <div className="h-6" />
    </div>
  );
}
